var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdificio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_5627",
    "data-name": "Grupo 5627",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 339.682,
    height: 319.024,
    viewBox: "0 0 339.682 319.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1704",
    "data-name": "Rect\\xE1ngulo 1704",
    width: 339.682,
    height: 319.024,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1675",
    "data-name": "Rect\\xE1ngulo 1675",
    width: 339.628,
    height: 319.024,
    fill: "#f1f7f8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5626",
    "data-name": "Grupo 5626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5625",
    "data-name": "Grupo 5625",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4487",
    "data-name": "Trazado 4487",
    d: "M229.942,65.9c0,5.073,4.373,9.185,9.768,9.185s9.767-4.112,9.767-9.185-4.373-9.185-9.767-9.185-9.768,4.112-9.768,9.185",
    transform: "translate(-53.238 -13.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4488",
    "data-name": "Trazado 4488",
    d: "M248.478,74.281a7.693,7.693,0,1,0,7.679-7.221,7.461,7.461,0,0,0-7.679,7.221",
    transform: "translate(-57.53 -15.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4489",
    "data-name": "Trazado 4489",
    d: "M215.113,73.783a7.693,7.693,0,1,0,7.679-7.221,7.46,7.46,0,0,0-7.679,7.221",
    transform: "translate(-49.805 -15.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4490",
    "data-name": "Trazado 4490",
    d: "M213.224,85.6H256.07a3.731,3.731,0,0,0,0-7.463H213.224a3.731,3.731,0,0,0,0,7.463",
    transform: "translate(-48.504 -18.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4491",
    "data-name": "Trazado 4491",
    d: "M96.753,50.744a4.971,4.971,0,1,0,4.961-4.665,4.82,4.82,0,0,0-4.961,4.665",
    transform: "translate(-22.401 -10.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4492",
    "data-name": "Trazado 4492",
    d: "M106.169,55a3.908,3.908,0,1,0,3.9-3.668,3.789,3.789,0,0,0-3.9,3.668",
    transform: "translate(-24.581 -11.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4493",
    "data-name": "Trazado 4493",
    d: "M89.221,54.746a3.908,3.908,0,1,0,3.9-3.668,3.789,3.789,0,0,0-3.9,3.668",
    transform: "translate(-20.657 -11.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4494",
    "data-name": "Trazado 4494",
    d: "M88.262,60.746h21.763a1.9,1.9,0,0,0,0-3.79H88.262a1.9,1.9,0,1,0,0,3.79",
    transform: "translate(-19.997 -13.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4495",
    "data-name": "Trazado 4495",
    d: "M370.594,72.867a4.971,4.971,0,1,0,4.961-4.665,4.82,4.82,0,0,0-4.961,4.665",
    transform: "translate(-85.804 -15.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4496",
    "data-name": "Trazado 4496",
    d: "M380.009,77.122a3.908,3.908,0,1,0,3.9-3.668,3.789,3.789,0,0,0-3.9,3.668",
    transform: "translate(-87.983 -17.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4497",
    "data-name": "Trazado 4497",
    d: "M363.062,76.869a3.908,3.908,0,1,0,3.9-3.668,3.789,3.789,0,0,0-3.9,3.668",
    transform: "translate(-84.06 -16.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4498",
    "data-name": "Trazado 4498",
    d: "M362.1,82.869h21.763a1.9,1.9,0,1,0,0-3.79H362.1a1.9,1.9,0,1,0,0,3.79",
    transform: "translate(-83.399 -18.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4499",
    "data-name": "Trazado 4499",
    d: "M46.255,214.2h0a1.02,1.02,0,0,1-1.02-1.02V198.393a1.02,1.02,0,1,1,2.04,0v14.788a1.02,1.02,0,0,1-1.02,1.02",
    transform: "translate(-10.473 -45.697)",
    fill: "#7a4aa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4500",
    "data-name": "Trazado 4500",
    d: "M103.767,214.2h0a1.02,1.02,0,0,1-1.021-1.02V198.393a1.02,1.02,0,1,1,2.04,0v14.788a1.019,1.019,0,0,1-1.019,1.02",
    transform: "translate(-23.789 -45.697)",
    fill: "#7a4aa8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1676",
    "data-name": "Rect\\xE1ngulo 1676",
    width: 58.474,
    height: 148.566,
    transform: "translate(29.152 166.548)",
    fill: "#f3e9fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1677",
    "data-name": "Rect\\xE1ngulo 1677",
    width: 34.337,
    height: 148.557,
    transform: "translate(87.626 166.557)",
    fill: "#dabef8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1678",
    "data-name": "Rect\\xE1ngulo 1678",
    width: 93.151,
    height: 25.637,
    transform: "translate(28.812 214.485)",
    fill: "#b47df0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1679",
    "data-name": "Rect\\xE1ngulo 1679",
    width: 18.698,
    height: 44.536,
    transform: "translate(38.331 270.239)",
    fill: "#b47df0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1680",
    "data-name": "Rect\\xE1ngulo 1680",
    width: 18.698,
    height: 44.536,
    transform: "translate(58.049 270.239)",
    fill: "#b47df0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1681",
    "data-name": "Rect\\xE1ngulo 1681",
    width: 5.864,
    height: 44.366,
    transform: "translate(71.139 270.323)",
    fill: "#7a4aa8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1682",
    "data-name": "Rect\\xE1ngulo 1682",
    width: 5.864,
    height: 44.366,
    transform: "translate(38.247 270.323)",
    fill: "#7a4aa8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1683",
    "data-name": "Rect\\xE1ngulo 1683",
    width: 20.653,
    height: 43.601,
    transform: "translate(94.596 271.089)",
    fill: "#b47df0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4501",
    "data-name": "Trazado 4501",
    d: "M254.58,114.177h0a1.02,1.02,0,0,1-1.02-1.02V98.369a1.02,1.02,0,1,1,2.04,0v14.788a1.02,1.02,0,0,1-1.02,1.02",
    transform: "translate(-58.707 -22.539)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4502",
    "data-name": "Trazado 4502",
    d: "M119.58,114.177h0a1.02,1.02,0,0,1-1.02-1.02V98.369a1.02,1.02,0,1,1,2.04,0v14.788a1.02,1.02,0,0,1-1.02,1.02",
    transform: "translate(-27.45 -22.539)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1684",
    "data-name": "Rect\\xE1ngulo 1684",
    width: 115.759,
    height: 224.889,
    transform: "translate(85.417 90.055)",
    fill: "#f9dbed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1685",
    "data-name": "Rect\\xE1ngulo 1685",
    width: 49.466,
    height: 224.889,
    transform: "translate(201.176 90.055)",
    fill: "#ed92c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1686",
    "data-name": "Rect\\xE1ngulo 1686",
    width: 165.734,
    height: 24.477,
    transform: "translate(84.907 120.143)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1687",
    "data-name": "Rect\\xE1ngulo 1687",
    width: 165.734,
    height: 24.477,
    transform: "translate(84.907 197.146)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1688",
    "data-name": "Rect\\xE1ngulo 1688",
    width: 88.222,
    height: 44.366,
    transform: "translate(99.695 270.069)",
    fill: "#ed92c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1689",
    "data-name": "Rect\\xE1ngulo 1689",
    width: 6.119,
    height: 44.195,
    transform: "translate(141.511 269.899)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1690",
    "data-name": "Rect\\xE1ngulo 1690",
    width: 6.119,
    height: 44.195,
    transform: "translate(181.628 269.899)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1691",
    "data-name": "Rect\\xE1ngulo 1691",
    width: 6.119,
    height: 44.195,
    transform: "translate(99.49 269.899)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4503",
    "data-name": "Trazado 4503",
    d: "M298.421,214.2h0a1.02,1.02,0,0,1-1.021-1.02V198.393a1.02,1.02,0,1,1,2.04,0v14.788a1.02,1.02,0,0,1-1.02,1.02",
    transform: "translate(-68.857 -45.697)",
    fill: "#1c747b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4504",
    "data-name": "Trazado 4504",
    d: "M355.932,214.2h0a1.02,1.02,0,0,1-1.02-1.02V198.393a1.02,1.02,0,1,1,2.04,0v14.788a1.02,1.02,0,0,1-1.02,1.02",
    transform: "translate(-82.173 -45.697)",
    fill: "#1c747b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1692",
    "data-name": "Rect\\xE1ngulo 1692",
    width: 58.474,
    height: 148.566,
    transform: "translate(222.934 166.548)",
    fill: "#daf4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1693",
    "data-name": "Rect\\xE1ngulo 1693",
    width: 34.337,
    height: 148.557,
    transform: "translate(281.408 166.557)",
    fill: "#a8e6eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1694",
    "data-name": "Rect\\xE1ngulo 1694",
    width: 93.151,
    height: 25.637,
    transform: "translate(222.594 214.485)",
    fill: "#26adb8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1695",
    "data-name": "Rect\\xE1ngulo 1695",
    width: 18.698,
    height: 44.536,
    transform: "translate(232.113 270.239)",
    fill: "#26adb8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1696",
    "data-name": "Rect\\xE1ngulo 1696",
    width: 18.698,
    height: 44.536,
    transform: "translate(251.831 270.239)",
    fill: "#26adb8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1697",
    "data-name": "Rect\\xE1ngulo 1697",
    width: 5.864,
    height: 44.366,
    transform: "translate(264.92 270.323)",
    fill: "#1c747b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1698",
    "data-name": "Rect\\xE1ngulo 1698",
    width: 5.864,
    height: 44.366,
    transform: "translate(232.028 270.323)",
    fill: "#1c747b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1699",
    "data-name": "Rect\\xE1ngulo 1699",
    width: 20.653,
    height: 43.601,
    transform: "translate(288.377 271.089)",
    fill: "#26adb8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4505",
    "data-name": "Trazado 4505",
    d: "M276.35,392.856a7.576,7.576,0,1,1-7.576-7.576,7.576,7.576,0,0,1,7.576,7.576",
    transform: "translate(-60.475 -89.204)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4506",
    "data-name": "Trazado 4506",
    d: "M262.95,399.765a5.956,5.956,0,1,1-5.956-5.956,5.956,5.956,0,0,1,5.956,5.956",
    transform: "translate(-58.123 -91.179)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4507",
    "data-name": "Trazado 4507",
    d: "M288.826,399.354a5.956,5.956,0,1,1-5.956-5.956,5.956,5.956,0,0,1,5.956,5.956",
    transform: "translate(-64.114 -91.083)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4508",
    "data-name": "Trazado 4508",
    d: "M281.941,409.1H249.079a3.077,3.077,0,1,1,0-6.155h32.862a3.077,3.077,0,1,1,0,6.155",
    transform: "translate(-56.957 -93.293)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4509",
    "data-name": "Trazado 4509",
    d: "M118.17,398.937a5.03,5.03,0,1,1-5.03-5.03,5.029,5.029,0,0,1,5.03,5.03",
    transform: "translate(-25.031 -91.201)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4510",
    "data-name": "Trazado 4510",
    d: "M109.273,403.524a3.954,3.954,0,1,1-3.955-3.954,3.955,3.955,0,0,1,3.955,3.954",
    transform: "translate(-23.469 -92.512)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4511",
    "data-name": "Trazado 4511",
    d: "M126.454,403.251A3.954,3.954,0,1,1,122.5,399.3a3.955,3.955,0,0,1,3.955,3.954",
    transform: "translate(-27.447 -92.449)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4512",
    "data-name": "Trazado 4512",
    d: "M121.883,409.721H100.063a2.043,2.043,0,1,1,0-4.087h21.819a2.043,2.043,0,1,1,0,4.087",
    transform: "translate(-22.695 -93.916)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4513",
    "data-name": "Trazado 4513",
    d: "M30.5,392.856a7.576,7.576,0,1,1-7.576-7.576,7.576,7.576,0,0,1,7.576,7.576",
    transform: "translate(-3.555 -89.204)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4514",
    "data-name": "Trazado 4514",
    d: "M17.1,399.765a5.956,5.956,0,1,1-5.956-5.956,5.956,5.956,0,0,1,5.956,5.956",
    transform: "translate(-1.202 -91.179)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4515",
    "data-name": "Trazado 4515",
    d: "M42.981,399.354a5.956,5.956,0,1,1-5.956-5.956,5.956,5.956,0,0,1,5.956,5.956",
    transform: "translate(-7.194 -91.083)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4516",
    "data-name": "Trazado 4516",
    d: "M36.1,409.1H3.234a3.077,3.077,0,1,1,0-6.155H36.1a3.077,3.077,0,1,1,0,6.155",
    transform: "translate(-0.036 -93.293)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1700",
    "data-name": "Rect\\xE1ngulo 1700",
    width: 3.346,
    height: 23.208,
    transform: "translate(314.508 287.926)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4517",
    "data-name": "Trazado 4517",
    d: "M421.373,333.9c0,14.682-6.235,26.584-13.925,26.584s-13.925-11.9-13.925-26.584,6.234-26.584,13.925-26.584,13.925,11.9,13.925,26.584",
    transform: "translate(-91.113 -71.153)",
    fill: "#1b4245"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1701",
    "data-name": "Rect\\xE1ngulo 1701",
    width: 2.558,
    height: 23.208,
    transform: "translate(326.747 288.141)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4518",
    "data-name": "Trazado 4518",
    d: "M435.093,341.249c0,12.127-5.149,21.959-11.5,21.959s-11.5-9.832-11.5-21.959,5.15-21.959,11.5-21.959,11.5,9.832,11.5,21.959",
    transform: "translate(-95.411 -73.925)",
    fill: "#2e6e73"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1702",
    "data-name": "Rect\\xE1ngulo 1702",
    width: 3.346,
    height: 23.208,
    transform: "translate(23.047 287.926)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4519",
    "data-name": "Trazado 4519",
    d: "M13.845,333.9c0,14.682,6.235,26.584,13.925,26.584s13.925-11.9,13.925-26.584-6.234-26.584-13.925-26.584S13.845,319.22,13.845,333.9",
    transform: "translate(-3.206 -71.153)",
    fill: "#1b4245"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1703",
    "data-name": "Rect\\xE1ngulo 1703",
    width: 2.558,
    height: 23.208,
    transform: "translate(11.595 288.141)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4520",
    "data-name": "Trazado 4520",
    d: "M1.585,341.249c0,12.127,5.15,21.959,11.5,21.959s11.5-9.832,11.5-21.959-5.15-21.959-11.5-21.959-11.5,9.832-11.5,21.959",
    transform: "translate(-0.367 -73.925)",
    fill: "#2e6e73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4521",
    "data-name": "Trazado 4521",
    d: "M417.21,393.565a6.981,6.981,0,1,1-6.982-6.982,6.982,6.982,0,0,1,6.982,6.982",
    transform: "translate(-93.364 -89.505)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4522",
    "data-name": "Trazado 4522",
    d: "M404.862,399.931a5.488,5.488,0,1,1-5.488-5.488,5.489,5.489,0,0,1,5.488,5.488",
    transform: "translate(-91.196 -91.325)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4523",
    "data-name": "Trazado 4523",
    d: "M428.709,399.552a5.488,5.488,0,1,1-5.488-5.488,5.489,5.489,0,0,1,5.488,5.488",
    transform: "translate(-96.717 -91.238)",
    fill: "#5ba7ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4524",
    "data-name": "Trazado 4524",
    d: "M423.181,408.532H391.26a2.018,2.018,0,0,1-2.018-2.018v-1.636a2.017,2.017,0,0,1,2.018-2.018h31.921a2.018,2.018,0,0,1,2.018,2.018v1.636a2.018,2.018,0,0,1-2.018,2.018",
    transform: "translate(-90.121 -93.274)",
    fill: "#5ba7ad"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdificio);
export default __webpack_public_path__ + "static/media/edificio.a69f4f7560b22600e29302c0600d8480.svg";
export { ForwardRef as ReactComponent };